/** Séance affichée dans le panneau « Votre réservation » (SPEC FC1) et sur la confirmation. */
import type { MindbodyClass, PickaspotClass } from 'types/class';
import { locationNameOf, type EventSplit } from '../../../lib/planning/eventStudios';
import { addressLine, coachName, longDate, studioLabel, timeRange } from './format';

export interface SessionInfo {
  date: string;
  time: string;
  studio: string;
  address: string;
  coach: string;
}

/** `classStartTime` Pick-a-Spot porte un « Z » mais c'est l'heure locale du site (= StartDateTime). */
export const pickaspotLocalTime = (value?: string | null) => (value ? value.replace(/Z$/, '') : undefined);

export function sessionOf(
  cls: MindbodyClass | undefined,
  pick: PickaspotClass | undefined,
  brandName: string,
  /** Studios virtuels du studio Monday Event de Paris (lib/planning/eventStudios.ts) ; null : nom Mindbody. */
  eventSplit: EventSplit | null = null,
): SessionInfo | null {
  const startRaw = cls?.StartDateTime ?? pickaspotLocalTime(pick?.classStartTime);
  if (!startRaw) return null;
  const start = new Date(startRaw);
  if (Number.isNaN(start.getTime())) return null;
  const endRaw = cls?.EndDateTime ?? pickaspotLocalTime(pick?.classEndTime);
  return {
    date: longDate(start),
    time: timeRange(start, endRaw ? new Date(endRaw) : null),
    studio: studioLabel(cls ? locationNameOf(cls, eventSplit) : undefined, brandName),
    address: addressLine(cls?.Location),
    coach: coachName(cls?.Staff),
  };
}
